import React from 'react';
import './ResourcesContent.css'; // Assuming you have a CSS file for styling
// import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';

const ResourcesContent = () => {
  return (
    <div className="resources">
        <div className="resources-overview-container">
          <div className="resources-overview-info">
            <h2 className="resources-overview-header">Extra Resources</h2>
            <div className="resources-custom-line"></div>
            <p className="resources-text">
              Northside Dental Partners is dedicated to providing you with a comfortable, relaxing environment during your appointment. Here you’ll find more patient-related information to make scheduling your first appointment a simpler process. Take a look at our new patient forms, insurance policy, frequently asked questions, and extended contact information down below. We hope to hear from you soon!
            </p>
            </div>
        </div>

        <div className="resource-subsection-container">
            <h3 className="resource-subsection-header">New Patient Information</h3>
            <p className="resource-subsection-text">
                If you are a new patient to our office, the attached file contains our new patient bundle with forms that will need to be filled out when you arrive at our office.  Printing them, filling them out, and bringing them with you will allow us to attend to your medical needs more quickly than completing them on your arrival.  Feel free to call our office if you have any questions on this!
            </p>
            <a href="/files/new-patient-form.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="pdf-button"> View New Patient Form
            </a>
        </div>

        <div className="resource-subsection-container">
            <h3 className="resource-subsection-header">Payment Information</h3>
            <p className="resource-subsection-text">
                For your convenience, we accept cash, all major credit cards and Care Credit. Payment is expected at the time services are performed.
            </p>
            <h4 className="resource-subsection-subheader">Insurance</h4>
            <p className="resource-subsection-text">
                As a service to our patients, our practice accepts most dental insurance programs, including non-managed care, indemnity (traditional), and PPO out-of-network.  We are not part of any managed care network.  Our office staff will prepare all the necessary forms for your dental benefits. However, we remind you that your specific policy is an agreement between you and your insurance company. Please keep in mind that you are responsible for your total obligation should your insurance benefits result in less coverage than anticipated. Our staff will gladly submit a pre-treatment estimate to your insurance company so that you will know what your benefits will be.
            </p>
            <p className="resource-subsection-text">
                The fees charged for services rendered to those who are insured are the usual and customary fees charged to all our patients for similar services. Your policy may base its allowances on a fixed fee schedule, which may or may not coincide with our usual fees. You should be aware that different insurance companies vary greatly in the types of coverage available. Also, some companies take care of claims promptly while others delay payment for several months.
            </p>
        </div>

        <div className="resource-subsection-container">
            <h3 className="resource-subsection-header">Contact Us</h3>
            <ul className="resource-subsection-list">
                <li><strong>Address:   </strong>8329 Roswell Road NE, Sandy Springs, GA 30350</li>
                <li><strong>Phone:      </strong>(770)-671-1111</li>
                <li><strong>Fax:          </strong>(770)-379-0992</li>
                <li><strong>Email:        </strong>northsidedental@bellsouth.net</li>
            </ul>
            <h4 className="resource-subsection-subheader">Hours</h4>
                <ul className="resource-subsection-list">
                    <li><strong>Monday: </strong> 9:00 am -  4:30 pm</li>
                    <li><strong>Tuesday: </strong> 9:00 am -  4:30 pm</li>
                    <li><strong>Wednesday: </strong> 9:00 am -  4:30 pm</li>
                    <li><strong>Thursday: </strong> 9:00 am -  4:30 pm</li>
                    <li><strong>Friday: </strong>Closed</li>
                    <li><strong>Saturday: </strong>Closed</li>
                    <li><strong>Sunday: </strong>Closed</li>
                </ul>
        </div>
    </div>
    );
}


export default ResourcesContent;